import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  title: 'Structure de livraison',
  subtitle: 'Choisissez le mode de livraison des commandes (par emplacement).',
  form: {
    delivery_mode: {
      label: 'Mode de livraison',
      placeholder: 'Sélectionner le mode de livraison',
      options: {
        [DeliveryMode.Internal]: 'Interne (propres livreurs)',
        [DeliveryMode.External]: 'Externe (prestataire)',
      },
    },
  },
  buttons: {
    back: 'Retour',
    next: 'Suivant',
    skip: 'Ignorer',
  },
  toasts: {
    error: "Une erreur s'est produite. Veuillez réessayer.",
  },
};
